/**
 * Wartet auf `work`, aber mindestens `ms` Millisekunden.
 *
 * Für Knöpfe wie „Jetzt testen“: Kommt die Antwort sofort, blitzt der Ladezustand
 * nur kurz auf und man sieht nicht, dass überhaupt geprüft wurde. Fehler kommen
 * ebenfalls erst nach der Mindestzeit, damit sich beide Fälle gleich anfühlen.
 */
export async function withMinimumDuration<T>(work: Promise<T>, ms: number): Promise<T> {
  const [result] = await Promise.allSettled([work, new Promise((resolve) => setTimeout(resolve, ms))]);
  if (result.status === "rejected") throw result.reason;
  return result.value;
}
